/* eslint-disable security/detect-object-injection */
/* eslint-disable no-console */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
import React, {
    useEffect, useContext,useMemo, useState, useCallback
} from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import _ ,{ debounce} from 'lodash';
import appConfig from 'app-config';
import { withRouter, Link } from 'react-router-dom';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Icon, ModalNextContext,Button} from '@jutro/components';

import {useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import { getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import moment from 'moment';
import ClaimLobOptionsMenu from '../ClaimLobOptionsMenu/ClaimLobOptionsMenu';
import VendorLinkComponent from '../VendorLinkComponent/VendorLinkComponent';
import metadata from './ClaimListComponent.metadata.json5';
import styles from '../../pages/ClaimList/ClaimList.module.scss';
import claimsMessages from '../../Claims.messages';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import { getDisplayClaimNumber } from 'gw-capability-gateway-claim-react/utils/ClaimUtil';

function ClaimListComponent({ history, setClaimsPromise, callLossRunDownloadClaimsReports, handleCorVelClaimsClick }) {
    const ModalNext = useContext(ModalNextContext);
    const { authHeader } = useAuthentication();
    const { vendorTypesForPolicyHolderByLob, claimsFilterLOBOptions } = appConfig;
    const [claimDataTable, setClaimDataTable] = useState([]);
    const [isLoading, setLoadingState] = useState(true);
    const translator = useTranslator();
    const [selectedClaimLOB, setSelectedClaimLOBe] = useState(translator(claimsMessages.allClaims));
    const [searchFilter, setSearchFilter] = useState(undefined);
    const [isClosed, setIsClosed] = useState(false);
    const [trackEvent] = usecpmiAnalytics();
    const[responseDataValues,setResponseDataValues]=useState([])

    const [LobArrayObject,setLobArrayObject]=useState([]);
    const [selectedClaimFilterValue,setSelectedClaimFilterValue]=useState('');
    const [responseClaimsObject, setResponseClaimsObject] =useState([]);
    const { refreshData } = useDataRefresh();
    const [config, setConfig] = useState(
        {

            filterValue: '',
            page: 0,
            pageSize: 25,
            sorted: [
                {
                    id: 'dateofloss',
                    desc: true,
                },
            ],
            key:"default"
        }
    );

    const getVendors = useCallback(
        (claim) => {
            if (!claim.vendors) {
                return [];
            }

            const normalizedLobCode = getNormalizedLOBName(claim.lineOfBusinessCode);
            const usedVendorTypes = vendorTypesForPolicyHolderByLob[normalizedLobCode] || [];

            const policyHolderVendors = claim.vendors.filter((vendor) => {
                let type = vendor.contactDTO.subtype;

                if (normalizedLobCode === 'ho') {
                    type = vendor.contactDTO.contactType;
                }

                return usedVendorTypes.indexOf(type) >= 0;
            });

            return policyHolderVendors;
        },
        [vendorTypesForPolicyHolderByLob]
    );

    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;

                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        product: claimInfo.lineOfBusinessCode,
                        productDesc: claimInfo.lineOfBusinessDesc,
                        claimNumber: claimInfo.claimNumber,
                        displayClaimNumber: getDisplayClaimNumber(claimInfo.claimNumber, claimInfo.lineOfBusinessCode, claimInfo.isTPA, claimInfo.claimState),
                        claimantName:claimInfo.claimantName,
                        claimStatusValue:claimInfo.claimStatusValue,
                        jurisdictionStateName:claimInfo.jurisdictionStateName,
                        dateOfLoss: moment(moment.utc(claimInfo.lossDate)).format('MMMM DD, YYYY'),
                        lossDate_Ext: claimInfo.lossDate_Ext,
                        status: translator({
                            id: `typekey.ClaimState.${claimInfo.claimState}`,
                            defaultMessage: claimInfo.claimState
                        }),
                        policyNumber: claimInfo.policyNumber,
                        uwingOrganization:claimInfo.uwingOrganization,
                        vendors: getVendors(claimInfo),
                        assignedAdjusterName:claimInfo.assignedAdjusterName
                    };

                    return claims;
                });

                return claimsArrayResult;
            }

            return [];
        },
        [getVendors, translator, getDisplayClaimNumber]
    );

    const getClaims = useCallback(
        (query, paginationParams) => {
            let data = []

            if(query.selecClaimFilter !== undefined){
                setSelectedClaimFilterValue('')
            }

                const accountNumber = _.isUndefined(history?.location?.state?.claimListComponentData) ? null : history?.location?.state?.claimListComponentData;
                const claimsPromise = ClaimService.getClaimSummaries(query, paginationParams, accountNumber, authHeader);

                return claimsPromise
                    .then((responseData) => {
                        setResponseClaimsObject(responseData.items);

                        if (!_.isUndefined(setClaimsPromise)) {
                            setClaimsPromise(responseData)
                        }

                        setResponseDataValues(responseData);
                        data = processClaimsData(responseData.items);
                        setClaimDataTable(data)
                        refreshData();

                        return { rows: data, numberOfRows: responseData.maxNumberOfResults }
                    })
                    .finally(() => {
                        setLoadingState(false);
                    });
        },
        [authHeader, history, processClaimsData, refreshData, setClaimsPromise]
    );

    const [reload, setReload] = useState(false)
    const onDeleteClaimIcon = useCallback((e, index, item) => {
        e.preventDefault();

        const claimData = claimDataTable;

        ModalNext.showConfirm({
            title: claimsMessages.removeClaim,
            message: claimsMessages.confirmRemoveClaim,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: claimsMessages.claimRemoveConfirmYes,
            cancelButtonText: claimsMessages.claimRemoveConfirmNo
        }).then(async (results) => {
            if (results === 'cancel') {
                return _.noop();
            }

            const claimsPromise = ClaimService.deleteSelectedClaim(item.claimNumber, authHeader);

             claimsPromise
                .then(() => {
                    claimData.splice(index,1)
                   setClaimDataTable(claimData)
                   setReload((value)=>!value)
                    setConfig((preValue) => ({
                        ...preValue,
                        page: 0,
                        pageSize: 25
                    }))
                   refreshData();
                })
                .finally(() => {

                });

            return true;
        }, _.noop);
    },
        [ModalNext, authHeader, claimDataTable, refreshData]
    );

    const getRemoveIcon = useCallback(
        (item, index) => (item.status !== "Draft")
                ?  ''
                :(
                    <a onClick={(e) => onDeleteClaimIcon(e, index, item)} className={styles.documentIcon}>
                    <Icon icon="gw-delete" /> Delete
                </a>

                ),
        [onDeleteClaimIcon]
    );

    useEffect(()=>{

        const claimsValues=[]

        if(!_.isEmpty(responseDataValues.items) && !_.isUndefined(history?.location?.state?.claimListComponentData)){
            responseDataValues.items.forEach((dataValue)=>{
                if(dataValue.accountNumber===history?.location?.state?.claimListComponentData){

                    claimsValues.push(dataValue)
                }
            })

            const data = processClaimsData(claimsValues);

            setClaimDataTable(data)
        }

        },[history?.location?.state?.claimListComponentData, processClaimsData, responseDataValues])

    const loadClaimData = useCallback(
        (filters,pageConfig) => {
            let claimStates = isClosed ? ['open', 'draft', 'closed'] : ['open', 'draft'];
            let policyType = selectedClaimLOB !== translator(claimsMessages.allClaims)
                ? selectedClaimLOB
                : undefined;
            let queryText = searchFilter;
            const startIndex = (pageConfig?.pageSize ?? 0) * (pageConfig?.page ?? 0);
            const offsetEndMinusOne = startIndex + (pageConfig?.pageSize ?? 0) - 1;
            const paginationParams = {
                offsetStart: startIndex,
                offsetEnd: offsetEndMinusOne,
                orderBy: pageConfig?.sorted.length > 0 ? pageConfig?.sorted[0]?.id: config?.sorted[0]?.id,
                orderByDescending:  pageConfig?.sorted.length > 0 ? pageConfig?.sorted[0]?.desc:config?.sorted[0]?.desc
            };

            if (!_.isUndefined(filters)) {
                if (!_.isUndefined(filters.isClosed)) {
                    claimStates = filters.isClosed
                        ? ['open', 'draft', 'closed']
                        : ['open', 'draft'];
                }

                if (!_.isUndefined(filters.policyType)) {
                    policyType = filters.policyType !== translator(claimsMessages.allClaims)
                        ? filters.policyType
                        : undefined;
                }

                queryText = !_.isUndefined(filters.queryText) ? filters.queryText : queryText;
            }

            if(selectedClaimFilterValue !=="" && selectedClaimFilterValue !=="All Lines Of Business"){
                policyType = selectedClaimFilterValue
            } else{
                policyType = undefined
            }


            const query = filters.selectClaimFilter !== undefined && filters.selectClaimFilter === "" ?
            {claimStates,
                policyType,
                queryText,
                selecClaimFilter: ""
            } : {
                claimStates,
                policyType,
                queryText
            };

            return getClaims(query, paginationParams);
        },
        [selectedClaimLOB, searchFilter, isClosed, selectedClaimFilterValue, config, getClaims, translator]
    );

    useEffect(() => {
        setSelectedClaimFilterValue('');
        setSelectedClaimLOBe(translator(claimsMessages.allClaims));

        const lobObjectArray = [];

        lobObjectArray.push({"name":"Commercial Auto","code":"CA7CommAuto"});
        lobObjectArray.push({"name":"Commercial Output Program","code":"CommercialOutputProgram"});
        lobObjectArray.push({"name":"Commercial Package","code":"CPP7CommercialPackage"});
        lobObjectArray.push({"name":"Commercial Property","code":"CP7CommercialProperty"});
        lobObjectArray.push({"name":"Commercial Umbrella","code":"CommercialUmbrella"});
        lobObjectArray.push({"name":"Crime","code":"CR7Crime"});
        lobObjectArray.push({"name":"General Liability","code":"GL7GeneralLiability"});
        lobObjectArray.push({"name":"Maritime Employers Liability","code":"MaritimeEmployerLiability"});
        lobObjectArray.push({"name":"Workers' Compensation","code":"WC7WorkersComp"});

        setLobArrayObject([]);
        setLobArrayObject(lobObjectArray);
    }, [setSelectedClaimFilterValue, translator]);

    useEffect(()=>{

        if(!_.isUndefined(history?.location?.state?.claimListComponentData)){
            setReload((value)=>!value)
            setConfig((preValue) => ({
                ...preValue,
                page: 0,
                pageSize: 25
            }))
        }
    },[history?.location?.state?.claimListComponentData])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleFilterChange = useCallback(
        debounce((value, id) => {
            if (id === 'LOBFilter' && value !== 'Filters') {
                setSelectedClaimLOBe(value);
                setConfig((preValue) => ({
                    ...preValue,
                    page: 0,
                    pageSize: 25
                }))

            }

            if (id === 'searchFilter') {
                setReload((toggle) => !toggle)
                setConfig((preValue) => ({
                    ...preValue,
                    page: 0,
                    pageSize: 25
                }))
            }

            if (id === 'closedFilter') {
                setIsClosed(value);
            }

            setConfig((preValue) => ({
                ...preValue,
                page: 0,
                pageSize: 25
            }))
        }, 500), // Debounce delay: 500ms
        [loadClaimData]
    );

    const handleClaimFilters = useCallback((value) => {
        setConfig((preValue) => ({
            ...preValue,
            page: 0,
            pageSize: 25
        }))
        setSelectedClaimFilterValue('');

        if(value === undefined){
            value = "All Lines Of Business"
        }

        setSelectedClaimFilterValue(value);

        const resultObj = [];
        const allClaimsData =[];

        // eslint-disable-next-line array-callback-return
        responseClaimsObject.map((loopItem)=>{
            if(loopItem.lineOfBusinessCode ===value){
                resultObj.push(loopItem);
            }else{
                allClaimsData.push(loopItem) ;
            }
        })

        if(value === "All Lines Of Business"){
            const data = processClaimsData(allClaimsData);

            setClaimDataTable(data);
            refreshData();
        }else{
            const data = processClaimsData(resultObj);

            setClaimDataTable(data);
            refreshData();
        }

    },[processClaimsData, refreshData, responseClaimsObject,setSelectedClaimFilterValue]
    )

    const getCell = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                product: translator(claimsMessages.line),
                dateOfLoss: translator(claimsMessages.dateOfLossClaimDetail)
            };

            return <span title={toolTipMessage[property.id]}>{item[property.id]}</span>;
        },
        [translator]
    );

    const getDateLossCell = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                product: translator(claimsMessages.line),
                lossDate_Ext: translator(claimsMessages.dateOfLossClaimDetail)
            };

            return <span title={toolTipMessage[property.id]}>{moment(item[property.id]).format('MMMM DD, YYYY')}</span>;

        },
        [translator]
    );

    const getStatusCell = useCallback(
        (item, index, property) => item[property.id],
        []
    );

    const getVendorsCell = useCallback((item, index, property) => {
        const vendors = item[property.id];

        return <VendorLinkComponent id="vendorsCell" vendors={vendors} />;
    }, []);

    const getLink = useCallback(
        (item, index, property) => {

            const toolTipMessage = {
                policyNumber: translator(claimsMessages.policyNumberClaimDetail),
                claimNumber: translator(claimsMessages.claimNumber)
            };

            if (
                property.id === 'displayClaimNumber'
                && item.status
                    === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'draft' })
            ) {
                const redirectpath = {
                    pathname: '/fnol-select-policy',
                    state: {
                        claimNumber: item.claimNumber,
                        redirectPath: '/claims',
                        claimStatus: item.status,
                        jurisdictionStateName:item.jurisdictionStateName,
                        displayClaimNumber:item.displayClaimNumber,
                        uwingOrganization:item?.uwingOrganization
                    }
                };

                return (
                    <Link
                        to={redirectpath}
                        className={styles.gwClaimsLinkContent}
                        title={toolTipMessage[property.id]}
                        onClick={() => trackEvent("Claim Details", "/claims/claimnumber")}
                    >
                        {item[property.id]}
                    </Link>
                );
            }

            const redirectRoute = property.id === 'policyNumber'
                ? `/claims/policy/${item.claimNumber}`
                : `/claims/${item.claimNumber}`;
            const redirectPath = {
                pathname: redirectRoute,
                state: {
                    claimNumber: item.claimNumber,
                    redirectPath: '/claims',
                    claimStatus: item.status,
                    displayClaimNumber:item.displayClaimNumber,
                    jurisdictionStateName:item.jurisdictionStateName,
                    uwingOrganization:item?.uwingOrganization,
                    lobName:item?.product

                }
            };

            return (
                <Link
                    to={redirectPath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage[property.id]}
                    onClick={() => trackEvent("Claim Details", "/claims/claimnumber")}
                >
                    {item[property.id]}
                </Link>

            );
        },
        [translator, trackEvent]
    );

    const getProductLine = useCallback((item) => {
        let line = ""

        if(item.product === "WC7Line" || item.product === "WC7WorkersComp" || item.product === "WC"){
            line="Workers' Compensation"
        }
        else if(item.product === "GL7Line"){
            line="General Liability"
        }
        else if(item.product === "CA7Line" || item.product === "CA7CommAuto"){
            line="Commercial Auto"
        }
        else if(item.product === "CP7Line"){
            line="Commercial Property"
        }else if(item.product === "CIMLine"){
            line="Commerical Inland Marine"
        }
        else{
            line=item.productDesc
        }

        return <span>{line}</span>
    }, []);

    const renderTrigger = useCallback(
        (dropDownProps, toggleMenu) => {
            const { isOpen } = dropDownProps;
            const menuClick = () => {
                toggleMenu(!isOpen);
            };

            return (
                <Button
                    onClick={menuClick}
                    role="menuitem"
                    icon="mi-expand-more"
                    iconPosition="right"
                >Filters</Button>
            );
        },
        []
    );

    const loadData = useCallback((fetchconfig) => {
        const data = loadClaimData({}, fetchconfig);

        return data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClosed, reload, selectedClaimFilterValue])

    const changeConfig = useCallback((sorting) => {
        const newConfig = {
            ...config,
            page: sorting.page,
            pageSize: sorting.pageSize,
            sorted: sorting.sorted
        };

        setConfig((prevalue)=>({
            ...prevalue,
            ...newConfig
        }));
    },[config])

    const generateOverrides = useMemo(() => {
        const lobOptionsOverrides = LobArrayObject.map((item, index) => ({
                [`dropdownClaimFiletrAction${index}`]: {
                    onClick:()=>handleClaimFilters(item.code),
                    value:selectedClaimFilterValue,
                    content:item.name

                },
                [`iconChecked${index}`]: {
                    visible:item.code === selectedClaimFilterValue
                },

            }));

        return Object.assign({}, ...lobOptionsOverrides);
    }, [LobArrayObject, handleClaimFilters, selectedClaimFilterValue]);

    const overrides = {
        claimListTableLoader: {
            loaded: !isLoading
        },
        claimLobOptionsMenuFilterActions:{
            renderTrigger,
            visible:false
        },
        claimTable: {
            onFetchData: loadData,
            key:reload,
            onConfigChange: changeConfig,
            config
        },
        searchFilter: {
            value: searchFilter,
            onValueChange: (value) => {
                setSearchFilter(value);
                handleFilterChange(searchFilter, 'searchFilter');
            }
        },
        closedClaims: {
            onValueChange: (value) => handleFilterChange(value, 'closedFilter'),
            value: isClosed,
        },
        noDataMessage: {
            // visible: _.isEmpty(claimDataTable) && !isLoading,
            visible: _.isEmpty(claimDataTable) ,
            // content: translator(claimsMessages.noClaimsResult)
        },
        claimLobOptionsMenu: {
            visible:false,
            values: [translator(claimsMessages.allClaims), ...claimsFilterLOBOptions],
            handleFilterChange,
            isClosed,
            selectedClaimLOB,
            isShowClosedClaimFilter: true
        },
        filterDropDownClaims: {
            availableValues:  LobArrayObject,
            onValueChange: handleClaimFilters,
            value:selectedClaimFilterValue
        },
        claimFIlterDropDownBtn:{
            data:LobArrayObject
        },
        ...generateOverrides
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell,
            getDateLossCell,
            getRemoveIcon,
            getLink,
            getProductIcon: getProductLine,
            getVendorsCell,
            getStatusCell,
            handleFilterValue: handleFilterChange,
            handleClosedClaims: setIsClosed,
            sortDate: DatatableUtil.sortDate,
            callLossRunDownloadClaimsReports,
            handleCorVelClaimsClick
        },
        resolveComponentMap: {
            claimloboptionsmenu: ClaimLobOptionsMenu
        }
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(ClaimListComponent);
